<script setup lang="ts">
</script>
<template>
  <div class="flex items-center justify-center absolute w-full h-full top-0 left-0 bg-white/75 backdrop-blur-sm">
    <slot />
  </div>
</template>
